import { render, staticRenderFns } from "./CPopover.vue?vue&type=template&id=c906de1c&scoped=true"
import script from "./CPopover.vue?vue&type=script&lang=js"
export * from "./CPopover.vue?vue&type=script&lang=js"
import style0 from "./CPopover.vue?vue&type=style&index=0&id=c906de1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c906de1c",
  null
  
)

export default component.exports